import rootReducer from './reducers/reducers';
import { thunk } from 'redux-thunk';
import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(thunk)
      .concat(logger),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
